export const RECEIVER_REJECTED_FILTERS = [
  {
    name: "user",
    value: [
      ["user", "id"],
      ["receiver", "id"],
    ],
    label: [
      ["user", "fullName"],
      ["receiver", "fullName"],
    ],
  },
  {
    name: "category",
    value: [["category", "id"]],
    label: [["category", "name"]],
  },

];

// SEARCH INPUT FILTERS

export const RECEIVER_REJECTED_SEARCH_FILTERS = {
  user: ["user", "fullName"],
  receiver: ["receiver", "fullName"],
  category: ["category", "name"],
  description: ["description"],
  amount: ["amount"],
};